import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';

import { UseOutletContext } from '../Main';
import { User } from '../../../models/user.model';
import { AppService } from '../../../models/app.service.model';
import { Company } from '../../../models/company.model';
import { Settings } from '../../../models/settings.model';
import { Contact } from '../../../models/contact.model';
import { GlobalSwal } from '../../../styles/swal.style';
import { TreasuryAccount } from '../../../models/treasury.account.model';
import { AccountingAccount } from '../../../models/accounting.account.model';
import { StateLanguage } from '../../../languages/config/StateLanguage';
import { AccountingAccountDA } from '../../../services/admin/accounting.account.service';
import { Error } from '../../../models/error.model';
import { CompanyAccountingAccounts } from '../../../models/company.accounting.accounts.model';
import { AccountingEntry } from '../../../models/accounting.entry.model';
import { getError } from '../../../languages/translations/response';
import { errorWebHandler } from '../../../scripts/error.web.handler.script';
import { Service } from '../../../models/service.model';
import { Product } from '../../../models/product.model';
import { StorageCenter } from '../../../models/storage.center.model';

export interface PurchasePageProps {};

type ContexType = {
  asideMinimize: string,
  setAsideMinimize: Dispatch<SetStateAction<string>>,
  setRoute: Dispatch<SetStateAction<{path: {root: string, branch: string} | null, company: boolean} | null>>,
  userLoggedIn: User | null,
  appServiceForUser: AppService | null,
  companyForUser: Company | null,
  settingsForCompany: Settings | null,
  accountingAccountsForCompany: AccountingAccount[] | null,
  accountingDebitEntriesForCompany: AccountingEntry[] | null,
  treasuryAccountsForCompany: TreasuryAccount[] | null,
  contactsForCompany: Contact[] | null,
  servicesForCompany: Service[] | null,
  productsForCompany: Product[] | null,
  storageCentersForCompany: StorageCenter[] | null,
  accountingTaxAccountsForCompany: AccountingAccount[] | null,
  accountingExpenseAccountsForCompany: AccountingAccount[] | null,
  setAccountingTaxAccountsForCompany: Dispatch<SetStateAction<AccountingAccount[] | null>>,
  setAccountingExpenseAccountsForCompany: Dispatch<SetStateAction<AccountingAccount[] | null>>,
  loadSettingsForCompany: Function,
  loadAccountingDebitEntriesForCompany: Function,
  loadContactsForCompany: Function,
  loadServicesForCompany: Function,
  loadProductsForCompany: Function,
  loadStorageCentersForCompany: Function
};

let errorResponse: Error, accountingTaxAccountsResponse: CompanyAccountingAccounts, accountingExpenseAccountsResponse: CompanyAccountingAccounts;

const PurchasePage: React.FunctionComponent<PurchasePageProps> = props => {
  const {asideMinimize, setAsideMinimize, setRoute, userLoggedIn, appServiceForUser, companyForUser, settingsForCompany, accountingAccountsForCompany, accountingDebitEntriesForCompany, treasuryAccountsForCompany, contactsForCompany, servicesForCompany, productsForCompany, storageCentersForCompany, loadSettingsForCompany, loadAccountingDebitEntriesForCompany, loadContactsForCompany, loadServicesForCompany, loadProductsForCompany, loadStorageCentersForCompany} = UseOutletContext()
  const {lang} = StateLanguage()

  const [accountingTaxAccountsForCompany, setAccountingTaxAccountsForCompany] = useState<AccountingAccount[] | null>(null)
  const [accountingExpenseAccountsForCompany, setAccountingExpenseAccountsForCompany] = useState<AccountingAccount[] | null>(null)

  const loadAccountingTaxAccountsForCompany = async (id_company: string) => {
    await AccountingAccountDA.getAccountingAccounts(id_company, ['1170', '1171'], [], []).then( (response) => {
      if (response.status === 200) {
        accountingTaxAccountsResponse = response.data
        setAccountingTaxAccountsForCompany(accountingTaxAccountsResponse.accounting_accounts)
      } else {
        errorResponse = response.data

        GlobalSwal.fire({
          title: getError(errorResponse.code, lang.code, errorResponse.message),
          text: lang.labels.sorryLooksLikeThereAreSomeErrorstryAgain,
          icon: 'error',
          confirmButtonText: lang.labels.okGotIt
        })
      }
    }).catch( (error) => {
      errorWebHandler(lang, error)
    })
  }

  const loadAccountingExpenseAccountsForCompany = async (id_company: string) => {
    await AccountingAccountDA.getAccountingAccounts(id_company, [], ['4','6'], []).then( (response) => {
      if (response.status === 200) {
        accountingExpenseAccountsResponse = response.data
        setAccountingExpenseAccountsForCompany(accountingExpenseAccountsResponse.accounting_accounts)
      } else {
        errorResponse = response.data

        GlobalSwal.fire({
          title: getError(errorResponse.code, lang.code, errorResponse.message),
          text: lang.labels.sorryLooksLikeThereAreSomeErrorstryAgain,
          icon: 'error',
          confirmButtonText: lang.labels.okGotIt
        })
      }
    }).catch( (error) => {
      errorWebHandler(lang, error)
    })
  }

  useEffect( () => {
    if (companyForUser) {
      loadAccountingTaxAccountsForCompany(companyForUser.id)
      loadAccountingExpenseAccountsForCompany(companyForUser.id)
      loadContactsForCompany(companyForUser.id)
      loadProductsForCompany(companyForUser.id)
      loadServicesForCompany(companyForUser.id)
      loadStorageCentersForCompany(companyForUser.id)
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyForUser])

  return (
    <Outlet context={{asideMinimize, setAsideMinimize, setRoute, userLoggedIn, appServiceForUser, companyForUser, settingsForCompany, accountingAccountsForCompany, accountingDebitEntriesForCompany, treasuryAccountsForCompany, contactsForCompany, servicesForCompany, productsForCompany, storageCentersForCompany, accountingTaxAccountsForCompany, accountingExpenseAccountsForCompany, setAccountingTaxAccountsForCompany, setAccountingExpenseAccountsForCompany, loadSettingsForCompany, loadAccountingDebitEntriesForCompany, loadContactsForCompany, loadStorageCentersForCompany}}></Outlet>
  );
}

export function UseOutletContextPurchase() {
  return useOutletContext<ContexType>()
};

export default PurchasePage;
